<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="$emit('update:visible', false)">
    <div v-if="videoSegments.length" style="max-height: 540px; overflow: auto">
      <div class="video-box" :class="{ 'is-playing': isPlaying }">
        <video ref="mainVideoRef" style="width: 100%" controls preload="auto" :src="videoSegments[0].url"></video>
        <span class="play-btn el-icon-video-play" @click="playVideos()"></span>
      </div>

      <div class="video-segment-list">
        <h3>视频构成片段</h3>

        <div class="segments">
          <div class="segment-item" :class="{ 'active-item': i === activeIndex }" v-for="(video, i) in videoSegments" :key="i">
            <div class="video-thumbnail">
              <span class="play-btn el-icon-video-play" @click="playSegment(i)"></span>
              <span class="duration">{{ video.duration }}s</span>
              <video v-if="video" :src="video.url"></video>
            </div>
          </div>
        </div>
      </div>

      <div class="config-form">
        <el-form :model="form" label-width="100px">
          <el-form-item label="脚本名称" prop="title">
            <el-input v-model="form.title" placeholder="请输入脚本名称"></el-input>
          </el-form-item>

          <el-form-item label="总时长" prop="title"> {{ form.duration }} </el-form-item>
          <el-form-item label="AI分析">
            <el-switch v-model="form.aiAnalysisEnabled"></el-switch>
            <p style="font-size: 12px">启用后, AI将自动分析视频内容, 识别并生成内容标签, 同时提供优化建议</p>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <template #confirm-btn>
      <el-button type="primary" icon="el-icon-check" @click="onCutConfirm">确认剪辑</el-button>
    </template>
  </Modal>
</template>

<script setup>
import { ref, computed } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import { getDuration } from '../utils'
// eslint-disable-next-line
const props = defineProps({
  segmentList: {
    type: Array,
    default: () => []
  },
  scriptInfo: {
    type: Object
  }
})
// eslint-disable-next-line
const emit = defineEmits(['confirm'])
const form = ref({ title: '', duration: 0, aiAnalysisEnabled: false })
const isPlaying = ref(false)

// 主视频引用与片段列表
const mainVideoRef = ref(null)

const videoSegments = computed(() => {
  if (!props.segmentList?.length) return []
  const list = props.segmentList.map((item) => item.materials?.find((v) => item.materialCheckedId === v.id)).filter((s) => s)
  return list
})

const activeIndex = ref(0)

const onModalOpen = () => {
  form.value = {
    ...form.value,
    title: props.scriptInfo.scriptName,
    duration: getDuration(props.segmentList)
  }
}

let currentIndex = 0
let onEndedHandler = null

function playVideos(segmentIndex = 0) {
  const videoEl = mainVideoRef.value
  if (!videoEl || !videoSegments.value || videoSegments.value.length === 0) return

  isPlaying.value = true
  currentIndex = segmentIndex
  activeIndex.value = segmentIndex

  onEndedHandler = () => {
    if (!isPlaying.value) return
    currentIndex += 1
    activeIndex.value = currentIndex
    if (currentIndex < videoSegments.value.length) {
      videoEl.src = videoSegments.value[currentIndex].url
      videoEl.play()
    } else {
      isPlaying.value = false
      activeIndex.value = 0
      videoEl.removeEventListener('ended', onEndedHandler)
      onEndedHandler = null
    }
  }

  videoEl.src = videoSegments.value[currentIndex].url
  videoEl.play()
  videoEl.addEventListener('ended', onEndedHandler)
}

function playSegment(segmentIndex) {
  const videoEl = mainVideoRef.value
  videoEl.pause()
  videoEl.removeEventListener('ended', onEndedHandler)
  playVideos(segmentIndex)
}

function onCutConfirm() {
  emit('confirm', { ...form.value })
}
</script>

<style scoped lang="scss">
@import '~common/styles/element-ui/variables.scss';
.video-box {
  position: relative;
  overflow: hidden;
  border-radius: 4px;

  video {
    height: 290px;
    // width: 100%;
    display: block;
  }
  &.is-playing {
    .play-btn {
      display: none;
    }
    &::after {
      display: none;
    }
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
    font-weight: 800;
    color: #fff;
    z-index: 2;
    cursor: pointer;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    z-index: 1;
    pointer-events: none;
  }
}

.video-segment-list {
  margin-top: 20px;
  .segments {
    display: flex;
    flex-wrap: wrap;

    .segment-item {
      width: 100px;
      margin-right: 4px;
      border-radius: 8px;
      overflow: hidden;
      border: 2px solid transparent;
      padding: 3px;

      &.active-item {
        border: 2px solid $primary-color;
      }

      .video-thumbnail {
        position: relative;
        overflow: hidden;
        border-radius: 6px;
        video {
          height: 52px;
          display: block;
          margin: 0 auto;
        }

        .play-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
          opacity: 0.8;
          color: #fff;
          z-index: 2;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }

        .duration {
          position: absolute;
          right: 0px;
          bottom: 0;
          color: #fff;
          font-size: 12px;
          z-index: 10;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 4px;
          padding: 0 2px;
          transform: scale(0.86);
          transform-origin: right bottom;
        }

        &::after {
          content: '';
          position: absolute;
          height: 52px;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.42);
          z-index: 1;
          pointer-events: none;
        }
      }
    }
  }
}

.config-form {
  margin-top: 20px;
  background: #f7f7f7;
  padding: 20px 5px;
}
</style>
